export default __webpack_public_path__ + "static/media/zoomed_horizontal_darktolight.543faeaf.png";